// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"888":"cdb95162","5265":"7de2427f"}[chunkId] + ".chunk.css";
};